import React from "react";
import { oauth2 as SMART } from "fhirclient";
import { FhirClientContext } from "../FhirClientContext";
import TokenDebugPanel from "./TokenDebugPanel";
import "./Patient.css";

function formatSmartError(error) {
    if (!error) {
        return "Unknown SMART client error.";
    }

    const lines = [];
    lines.push(error.message || String(error));

    if (error.status) {
        lines.push(`status: ${error.status}`);
    }

    if (error.url) {
        lines.push(`url: ${error.url}`);
    }

    if (error.response && typeof error.response === "string") {
        lines.push(`response: ${error.response}`);
    }

    const params = new URLSearchParams(window.location.search);
    const authError = params.get("error");
    const authDescription = params.get("error_description");
    if (authError || authDescription) {
        lines.push(`callback error: ${authError || ""}`.trim());
        lines.push(`callback error_description: ${authDescription || ""}`.trim());
    }

    if (error.stack) {
        lines.push(error.stack);
    }

    return lines.filter(Boolean).join("\n");
}

export default class FhirClientProvider extends React.Component {
    componentDidMount() {
        SMART.ready().then(
            (client) => this.setState({ client }),
            (error) => {
                // Keep a rich error object for easier troubleshooting in browser devtools.
                // eslint-disable-next-line no-console
                console.error("SMART.ready() failed", error);
                this.setState({ error, errorText: formatSmartError(error) });
            }
        );
    }

    render() {
        return (
            <FhirClientContext.Provider value={this.state || {}}>
                <FhirClientContext.Consumer>
                    {({ client, error }) => {
                        // any error that SMART.ready() may have been rejected with
                        if (error) {
                            return <pre className="patient-message patient-message--error">{this.state?.errorText || error.stack}</pre>;
                        }

                        // if client is already available render the subtree
                        if (client) {
                            // Extract access token from the client state
                            const token = client.state?.tokenResponse?.access_token;
                            return (
                                <>
                                    {this.props.children}
                                    <TokenDebugPanel token={token} />
                                </>
                            );
                        }

                        // client is undefined until SMART.ready() is fulfilled
                        return <p className="patient-message">Authorizing...</p>;
                    }}
                </FhirClientContext.Consumer>
            </FhirClientContext.Provider>
        );
    }
}
